export default __webpack_public_path__ + "static/note-2210eb1926c267a4ca80c0e1ef44dc85.svg";